// ---------------------------------------------------------------------------
// Cloudflare Web Analytics, loaded only after Accept (B98, founder's ruling 2026-10-10).
//
// Until B98 Cloudflare INJECTED this beacon at the edge into every page of both
// hostnames (measured 2026-10-10: token below, posting each page view and SPA
// navigation to /cdn-cgi/rum). An edge-injected script cannot be stopped by
// the page, so the Cookie Policy's "set only after you consent" was untrue.
// The fix is two halves:
//   · 👤 Cloudflare dashboard → Web Analytics → recurr.co.za: automatic setup
//     switched to "JS snippet installation" (nothing deploys this);
//   · this file: the SPA adds the documented snippet itself, after Accept.
// ⚠ Until the dashboard half is done Cloudflare still injects it for everyone,
// and `loadCloudflareAnalytics` sees that script and adds no second one.
//
// The snippet sets no `version`, so the beacon reports to
// https://cloudflareinsights.com/cdn-cgi/rum (read off beacon.min.js) — which
// is why the SPA's CSP names that host in connect-src.
// ---------------------------------------------------------------------------

/** The site token Cloudflare's injected tag carried on 2026-10-10. Public: it is in every page. */
export const CF_BEACON_TOKEN = '4fa177ebf8184afa9cb47ad88aabe3e7';
export const CF_BEACON_SRC = 'https://static.cloudflareinsights.com/beacon.min.js';

/** True when a beacon is on the page already — ours, or Cloudflare's own injection. */
export function cloudflareBeaconPresent(): boolean {
  return document.querySelector('script[src^="https://static.cloudflareinsights.com/beacon"]') !== null;
}

/** Adds the beacon once. Returns true when this call added it. */
export function loadCloudflareAnalytics(): boolean {
  if (cloudflareBeaconPresent()) return false;
  const s = document.createElement('script');
  s.defer = true;
  s.src = CF_BEACON_SRC;
  s.setAttribute('data-cf-beacon', JSON.stringify({ token: CF_BEACON_TOKEN, spa: true }));
  s.setAttribute('data-recurr-consent', 'analytics');
  document.head.appendChild(s);
  return true;
}

/** True when the beacon on the page is the one THIS file added (so a reload removes it). */
export function cloudflareAnalyticsLoadedByUs(): boolean {
  return document.querySelector('script[data-recurr-consent="analytics"]') !== null;
}
